module.exports = __webpack_public_path__ + "img/stackslash-process-3.9ec357e4.jpg";